const htmlElementsRegex = /<[^>]*>/g;
const spaceHtmlCodesRegex = /&nbsp;/g;
const styleElementsRegex = /<style[^>]*>[\s\S]*?<\/style>/g;
const whitespaceRegex = /\s+/g;

/**
 * Extracts the widget ID from a Pagebuilder CMS block.
 *
 * The Pagebuilder HTML contains a single <p> tag with the widget ID inside it.
 *
 * @param block - The HTML block containing the widget ID.
 * @returns The widget ID if found, otherwise undefined.
 */
export function getWidgetId(block?: string) {
    if (!block) {
        return undefined;
    }

    try {
        const textContent = block
            .replace(styleElementsRegex, '')
            .replace(htmlElementsRegex, '')
            .replace(spaceHtmlCodesRegex, '')
            .replace(whitespaceRegex, '')
            .replace(' ', '')
            .trim();

        if (textContent.length > 0) {
            return textContent;
        }
    } catch (error) {
        console.error('Error extracting widget ID:', error);
    }

    return undefined;
}
